import { useInRouterContext, useLocation } from 'react-router-dom';
import { pageInfoFor } from '../navigation/catalog';

/**
 * The one line that says what the page at the current address is for, in the
 * catalogue's words (navigation/catalog PAGE_INFO). The same line the section front
 * page and page search show for it, so a page never describes itself two ways.
 *
 * Null when the address has no catalogue entry (a detail screen, a page the catalogue
 * does not list): the caller then draws nothing.
 *
 * This returns the words only; the caller draws them. Draw them as ONE line under the
 * title, never a wrapped paragraph: `truncate` on the element, the whole text in its
 * `title`, inside a `min-w-0` box (see ReportPageScaffold).
 */
export function usePageLine(): string | null {
  // Many page tests mount a page on its own, with no router around it, where
  // useLocation throws. A component lives inside a router for its whole life or not at
  // all, so which branch runs never changes between renders of the same component.
  const inRouter = useInRouterContext();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pathname = inRouter ? useLocation().pathname : null;
  return pathname ? pageInfoFor(pathname)?.line ?? null : null;
}
